export const name = 'isPassword';
var Requirements;
(function (Requirements) {
    Requirements[Requirements["MinimumLength"] = 8] = "MinimumLength";
    Requirements[Requirements["MaximumLength"] = 140] = "MaximumLength";
})(Requirements || (Requirements = {}));
/**
 * Determine if value matches criteria to be a password
 *
 * @param {string} value Value to make determination on
 */
const isPassword = async (value) => {
    const { length } = value.trim();
    return length >= Requirements.MinimumLength && length <= Requirements.MaximumLength;
};
isPassword.defaultMessage = `Please enter a valid password.
Password must be between ${Requirements.MinimumLength} and ${Requirements.MaximumLength} characters.`;
export { isPassword };
